export default "__VITE_ASSET__CAwzOcUb__"